<div class="p-4 mt-16 md:mt-0">
  <div class="flex justify-end mb-4">
    <sbnb-close (click)="onClose()"></sbnb-close>
  </div>
  <h2>Adjustment handling suggestion</h2>

  <div class="flex items-center gap-3">
    <span class="flex items-center gap-1">
      <sbnb-icon [size]="16" icon="calendar" class="text-smoke-darker"></sbnb-icon>
      <span class="text-sm">{{ adjustment.date | date: 'mediumDate' }}</span>
    </span>
    <span class="flex items-center gap-1">
      <sbnb-icon [size]="16" icon="properties" class="text-smoke-darker"></sbnb-icon>
      <span class="text-sm">{{ adjustment.reservation.property_name }}</span>
    </span>
    <span class="flex items-center gap-1">
      <sbnb-icon [size]="16" icon="adults" class="text-smoke-darker"></sbnb-icon>
      <span class="text-sm">{{ adjustment.reservation.guest_name }}</span>
      <span class="text-smoke-darker">|</span>
      <sbnb-copy-to-clipboard [content]="adjustment.reservation.code">
        <span class="text-sm">{{ adjustment.reservation.code | uppercase }}</span>
      </sbnb-copy-to-clipboard>
    </span>
  </div>
  <p class="max-w-[500px]">{{ adjustment.ai_reasoning }}</p>
  <p class="max-w-[500px]">{{ adjustment.details }}</p>
  <div class="flex items-center gap-2 mb-6">
    <sbnb-icon icon="magic"></sbnb-icon>
    <span class="strong">{{ 'CORE.PRODUCT_NAME' | transloco }} suggests...</span>
  </div>

  <form [formGroup]="form">
    <div class="flex flex-col gap-4">
      <!-- Classifications -->
      <div class="flex flex-col gap-4" formArrayName="accounts">
        <div
          *ngFor="let account of accounts.controls; let i = index"
          [formGroupName]="i"
          class="flex items-center gap-4">
          <mat-form-field class="nopadding flex-grow">
            <mat-select formControlName="type" data-adjustment-account-type>
              <mat-option *ngFor="let option of accountOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="nopadding">
            <span matPrefix>$&nbsp;</span>
            <input matInput type="number" formControlName="amount" data-adjustment-account-amount />
          </mat-form-field>

          <sbnb-icon
            class="clickable"
            icon="delete-smoke"
            (click)="removeAccount(i)"
            matTooltip="Remove classification"></sbnb-icon>
        </div>
      </div>

      <!-- Transactions -->
      <div class="flex flex-col gap-4" formArrayName="transactions">
        <div
          *ngFor="let transaction of transactions.controls; let i = index"
          [formGroupName]="i"
          class="flex items-center gap-4">
          <mat-form-field class="nopadding">
            <mat-select formControlName="category" data-adjustment-transaction-category>
              <ng-container *ngIf="transactionConfiguration$ | async as transactionConfiguration">
                @for (group of transactionConfiguration.categories; track group) {
                  @if (group.children?.length) {
                    <mat-optgroup [label]="group.label">
                      @for (child of group.children; track child) {
                        <mat-option [value]="child.value">{{ child.label | titlecase }}</mat-option>
                      }
                      <mat-option [value]="group.value">{{ group.label | titlecase }} (Uncategorized)</mat-option>
                    </mat-optgroup>
                  } @else {
                    <mat-option [value]="group.value">{{ group.label | titlecase }}</mat-option>
                  }
                }
              </ng-container>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="nopadding">
            <span matPrefix>$&nbsp;</span>
            <input matInput type="number" formControlName="amount" data-adjustment-transaction-amount />
          </mat-form-field>
          <sbnb-icon
            class="clickable"
            icon="delete-smoke"
            (click)="removeTransaction(i)"
            matTooltip="Remove transaction"></sbnb-icon>
        </div>
      </div>

      <sbnb-button
        type="secondary"
        size="mini"
        label="+ Add Classification"
        (clicked)="addAccount()"
        [splitMenu]="addMenu"></sbnb-button>
      <mat-menu #addMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="addTransaction()">+ Add Transaction</button>
      </mat-menu>

      <div class="flex flex-col items-end gap-2">
        <div class="flex items-center gap-4">
          <span class="text-sm text-night">Total:</span>
          <span [class.text-rose-darker]="form.errors?.sumEquals" class="font-mono">
            {{ adjustment.currency | currencyCode }}{{ totalAmount | number: '1.2-2' }}
          </span>
        </div>

        <div *ngIf="form.errors?.sumEquals" class="text-sm text-rose-darker">
          ({{ adjustment.currency | currencyCode }}{{ remainingAmount | number: '1.2-2' }} remaining of
          {{ adjustment.currency | currencyCode }}{{ adjustment.amount }} )
        </div>
      </div>

      <div class="flex justify-end gap-4">
        <sbnb-button type="secondary" (clicked)="onClose()" data-adjustment-cancel>Cancel</sbnb-button>
        <sbnb-button
          type="primary"
          [disabled]="form.invalid || (saving$ | async)"
          [loading]="saving$ | async"
          loadingLabel="Applying..."
          label="Apply"
          (clicked)="onApply()"></sbnb-button>
      </div>
    </div>
  </form>
</div>
